/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { uiEvent, uiElement } from "@kluntje/core";
import { FormField } from "Components/abstract/wec-e-form-field/wec-e-form-field";
import { render, TemplateResult } from "lit-html";

import { TextareaTemplateArgs } from "./wec-e-textarea.template";

export class VicTextarea extends FormField {
  textareaTemplate?: (args: TextareaTemplateArgs) => TemplateResult;
  @uiElement(".wec-js-form-field__input")
  input: HTMLInputElement;

  get minlength(): number | undefined {
    const curMinlength = this.getAttribute("minlength");
    if (curMinlength === null) return undefined;
    return parseInt(curMinlength, 10);
  }

  get maxlength(): number | undefined {
    const curMaxlength = this.getAttribute("maxlength");
    if (curMaxlength === null) return undefined;
    return parseInt(curMaxlength, 10);
  }

  get rowsCount(): string | undefined {
    return this.getAttribute("rows") || undefined;
  }

  get initialValue(): string {
    return this.getAttribute("initial-value") || "";
  }

  /**
   * Returns the submit-value of the form-field
   * @returns {string}
   */
  get submitValue(): string {
    return this.ui.input?.value || "";
  }

  async renderAsync() {
    try {
      this.textareaTemplate = await this.loadTemplate();
      this.renderComponent();
    } catch (e) {
      console.error("TextArea:", e);
    }
  }

  async loadTemplate(): Promise<(args: TextareaTemplateArgs) => TemplateResult> {
    const { textareaTemplate } = await import("./wec-e-textarea.template");
    return textareaTemplate;
  }

  @uiEvent("input", "keyup")
  handleKeyup() {
    this.hasExternalError = false;
    this.renderComponent();
  }

  renderComponent() {
    if (this.textareaTemplate === undefined) return;
    if (this.state.inValidationMode) this.validate();
    render(
      this.textareaTemplate({
        component: this,
      }),
      this.getUiRoot(),
    );
  }

  afterComponentRender() {
    if (this.initialValue !== "") {
      this.ui.input.value = this.initialValue;
      this.renderComponent();
    }
    super.afterComponentRender();
  }

  onChange() {
    // to fix inheritance bug with kluntje decorators
    // @TODO: Remove later
  }

  onFocus(e: FocusEvent) {
    // to fix inheritance bug with kluntje decorators
    // @TODO: Remove later
  }
}

customElements.define("wec-e-textarea", VicTextarea);
